import { createRouter, createWebHistory } from 'vue-router'
import App from '../App.vue'
import ManageLogin from '../views/ManageLogin.vue'
import OrderList from '../views/manage/OrderList.vue'
import UserList from '../views/manage/UserList.vue'
import Profile from '../views/manage/Profile.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: App
  },
  {
    path: '/manage/login',
    name: 'ManageLogin',
    component: ManageLogin
  },
  {
    path: '/manage/order/list',
    name: 'OrderList',
    component: OrderList
  },
  {
    path: '/manage/user/list',
    name: 'UserList',
    component: UserList
  },
  {
    path: '/manage/profile',
    name: 'Profile',
    component: Profile
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
